<template>
  <div class="page-container">
    <div class="content-left">
      <tree-select
        ref="treeSelect"
        :treeData="treeData"
        @handleChangeNode="handleChangeNode"
      ></tree-select>
    </div>
    <div class="content-right">
      <div class="searchbar">
        <el-form
          :inline="true"
          :model="filters"
          size="small"
          @keyup.enter.native="handleSearch()"
        >
          <el-row>
            <el-col :span="24" style="text-align: right">
              <el-form-item class="fl">
                <el-button
                  :type="pageType === 1 ? 'primary' : ''"
                  size="small"
                  @click="handleChangePageType(1)"
                  >图表</el-button
                >
              </el-form-item>
              <el-form-item class="fl">
                <el-button
                  :type="pageType === 0 ? 'primary' : ''"
                  size="small"
                  @click="handleChangePageType(0)"
                  >数据</el-button
                >
              </el-form-item>
              <el-form-item label="时间类型">
                <el-select v-model="filters.dateType" style="width: 100px">
                  <el-option label="日" value="HOUR"></el-option>
                  <el-option label="月" value="DAY"></el-option>
                  <el-option label="年" value="MONTH"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-date-picker
                  v-if="filters.dateType == 'HOUR'"
                  v-model="filters.startDate"
                  :picker-options="startOptions"
                  type="date"
                  format="yyyy/MM/dd"
                  placeholder="选择日期"
                ></el-date-picker>
                <el-date-picker
                  v-if="filters.dateType == 'DAY'"
                  v-model="filters.startDate"
                  :picker-options="startOptions"
                  type="month"
                  format="yyyy/MM"
                  placeholder="选择日期"
                ></el-date-picker>
                <el-date-picker
                  v-if="filters.dateType == 'MONTH'"
                  v-model="filters.startDate"
                  :picker-options="startOptions"
                  type="year"
                  format="yyyy"
                  placeholder="选择日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button :size="size" type="primary" @click="handleSearch()"
                  >查询</el-button
                >
                <el-button :size="size" type="primary" @click="bindExportExc()"
                  >导出</el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="content">
        <data-table
          v-if="pageType === 0"
          ref="dataTable"
          :tableData="dataList"
          :dateType="filters.dateType"
          style="height: 100%"
        ></data-table>
        <bar-charts v-if="pageType === 1" ref="barCharts" id="bar"></bar-charts>
      </div>
    </div>
  </div>
</template>

<script>
import dataTable from "./components/dataTable.vue";
import treeSelect from "./components/treeSelecter.vue";
import barCharts from "./components/barCharts.vue";
import moment from "moment";
import api from "@common/api/index.js";
import { exportExcel, findDataByParam } from "@/utils/index.js";
export default {
  components: {
    treeSelect,
    dataTable,
    barCharts,
  },
  data() {
    return {
      treeId: "10699393912217634",
      treeData: [],
      dataList: [],
      allId: [],
      filters: {
        startDate: new Date(),
        endDate: new Date(),
        dateType: "DAY",
        interval: "DAY",
      },
      configCode: "",
      pageType: 0,
      columns: [],
    };
  },
  mounted() {
    this.handleGetTreeData();
    // this.handleGetTableData(this.treeId, false);
  },
  methods: {
    tofix(cellValue) {
      if (cellValue !== "" && cellValue !== null) {
        return parseFloat(cellValue).toFixed(2);
      } else {
        return "--";
      }
    },
    totalTofix(cellValue) {
      if (cellValue !== "" && cellValue !== null) {
        return parseFloat(cellValue).toFixed(2);
      } else {
        return 0;
      }
    },
    handleChangePageType(val) {
      if (val === 0) {
        this.pageType = val;
        this.$nextTick(() => {
          this.handleGetTableData(this.treeId, false);
        });
      } else {
        if (
          this.configCode === "" ||
          this.configCode === null ||
          this.configCode === undefined
        ) {
          return this.$message.warning("暂未选中节点");
        }
        this.pageType = val;
        this.handleChartInit();
      }
    },
    handleGetTreeData() {
      let vm = this;
      api.frontEndPageCustomParam
        .getMyFrontEndPageCustomParam(0, "/statisticalReport/index", null)
        .then((resParam) => {
          if (resParam.success) {
            const id = findDataByParam("viewId", false, resParam.data);
            vm.treeId = id;
            api.view.getViewTreeNodes(vm.treeId).then((res) => {
              if (res.success) {
                vm.treeData = res.data;
                vm.allId = vm.treeData.map((item) => {
                  return item.measureId;
                });

                vm.handleGetTableData(vm.treeId, false);
              }
            });
          }
        });
    },
    handleGetTableData(measureId, isMeasureId = false) {
      const dateTime = moment(this.filters.startDate).format(
        "YYYY/MM/DD HH:mm:ss"
      );
      const id = measureId ? measureId : this.treeId;
      // console.log(params)
      api.view
        .getElectricityConsumption({
          id,
          dateTime,
          isMeasureId,
          interval: this.filters.dateType,
        })
        .then((res) => {
          if (res.success) {
            let power = res.data;
            let allList = ["A", "B", "C", "D"];
            let headercolumns = [];
            let otherColumns = [];
            for (let i = 0; i < power.length; i++) {
              if (allList.indexOf(power[i].configType) !== -1) {
                headercolumns.push({
                  assetsFixed: power[i].configType,
                  label: power[i].deviceName,
                  measureId: power[i].measureId,
                  propObject: [
                    {
                      name: "总用电量",
                      prop: power[i].configType + "total",
                    },
                    {
                      name:
                        this.filters.interval === "DAY"
                          ? "平均每日用电量"
                          : "平均每月用电量",
                      prop: power[i].configType + "avgE",
                    },
                    {
                      name: "用电量",
                      prop: power[i].configType + "hour",
                    },
                  ],
                });
              } else {
                otherColumns.push({
                  assetsFixed: power[i].configType,
                  label: power[i].deviceName,
                  measureId: power[i].measureId,
                  propObject: [
                    {
                      name: "总用电量",
                      prop: power[i].configType + "total",
                    },
                    {
                      name: this.handleName(),
                      prop: power[i].configType + "avg",
                    },
                  ],
                });
              }
            }
            this.$refs.dataTable.changeColumns([]);
            this.columns = this.columns.concat(headercolumns, otherColumns);
            this.$refs.dataTable.changeColumns(headercolumns, otherColumns);
            this.$nextTick(() => {
              this.handleTableData(power, headercolumns, otherColumns);
            });
          }
        });
    },
    handleTableData(data) {
      let tableList = [];
      this.dataList = [];
      try {
        for (let i = 0; i < data.length; i++) {
          for (let j = 0; j < data[i].powerConsumptionList.length; j++) {
            tableList[j] === undefined
              ? (tableList[j] = {})
              : (tableList[j] = tableList[j]);
            tableList[j][
              data[i].configType + "total" + data[i].measureId
            ] = this.tofix(data[i].totalElectricity);
            tableList[j][
              data[i].configType + "avgE" + data[i].measureId
            ] = this.tofix(data[i].avgElectricity);
            tableList[j][
              data[i].configType + "avg" + data[i].measureId
            ] = this.tofix(data[i].powerConsumptionList[j].v);
            tableList[j][
              data[i].configType + "hour" + data[i].measureId
            ] = this.tofix(data[i].powerConsumptionList[j].v);
            tableList[j]["time"] = this.handleTime(
              data[i].powerConsumptionList[j].time
            );
          }
        }
      } catch (error) {
        console.log(error);
      }
      this.dataList = tableList.reverse();
      console.log(this.dataList);
    },
    handleName() {
      let name = "";
      switch (this.filters.interval) {
        case "HOUR":
          name = "时用电量";
          break;
        case "DAY":
          name = "每日用电量";
          break;
        case "MONTH":
          name = "每月用电量";
          break;
        default:
          break;
      }
      return name;
    },
    handleTime(val) {
      let time = "";
      switch (this.filters.interval) {
        case "HOUR":
          time = moment(val).format("YYYY-MM-DD HH:mm:ss");
          break;
        case "DAY":
          time = moment(val).format("YYYY-MM-DD");
          break;
        case "MONTH":
          time = moment(val).format("YYYY-MM");
          break;
      }
      return time;
    },
    handleChartInit() {
      let xAxisData = [];
      let series = [];
      let dateTime = moment(this.filters.startDate).format(
        "YYYY/MM/DD HH:mm:ss"
      );
      let legendData = [];
      let option = {};
      let currentPowerConsumption = [];
      let lastpowerConsumptionList = [];
      switch (this.filters.dateType) {
        case "HOUR":
          this.filters.interval = "HOUR";
          for (let i = 1; i < 25; i++) {
            xAxisData.push(i + "时");
          }
          legendData = ["上日", "今日"];
          break;
        case "DAY":
          this.filters.interval = "DAY";
          for (let i = 1; i < 32; i++) {
            xAxisData.push(i + "日");
          }
          legendData = ["上月", "今月"];
          break;
        case "MONTH":
          this.filters.interval = "MONTH";
          for (let i = 1; i < 13; i++) {
            xAxisData.push(i + "月");
          }
          legendData = ["去年", "今年"];
          break;
        default:
          break;
      }

      api.view
        .getPowerChart({
          measureId: this.configCode,
          dateTime,
          interval: this.filters.interval,
        })
        .then((res) => {
          if (res.success) {
            lastpowerConsumptionList = res.data.lastpowerConsumptionList.map(
              (item) => {
                return this.tofix(item.v);
              }
            );
            currentPowerConsumption = res.data.currentPowerConsumption.map(
              (item) => {
                return this.tofix(item.v);
              }
            );
            series = [
              {
                type: "bar",
                name: legendData[0],
                data: lastpowerConsumptionList,
              },
              {
                type: "bar",
                name: legendData[1],
                data: currentPowerConsumption,
              },
            ];
            option = {
              tooltip: {
                trigger: "axis",
                axisPointer: {
                  type: "shadow",
                },
              },
              legend: {
                left: "5%",
                data: legendData,
              },
              color: ["rgba(74, 144, 226, 0.6)", "rgba(61, 204, 133, 0.6)"],
              grid: {
                top: "5%",
                left: "3%",
                right: "4%",
                bottom: "3%",
                containLabel: true,
              },
              xAxis: {
                type: "category",
                data: xAxisData,
              },
              yAxis: [
                {
                  type: "value",
                },
              ],
              series: series,
            };
            this.$nextTick(() => {
              this.$refs.barCharts.init(option);
            });
          }
        });
    },
    handleChangeNode(node) {
      console.log(node);
      this.configCode = node.measureId;
      if (this.pageType === 0) {
        this.handleGetTableData(node.measureId, true);
      } else {
        this.handleChartInit();
      }
    },
    handleSearch() {
      if (this.pageType === 0) {
        this.handleGetTableData();
      } else {
        this.handleChartInit();
      }
    },

    bindExportExc() {
      //表格导出
      let name = "电量统计报表";
      let dateType = "";
      switch (this.filters.interval) {
        case "HOUR":
          dateType = "day";
          break;
        case "DAY":
          dateType = "month";
          break;
        case "MONTH":
          dateType = "year";
          break;
      }
      let selectedDate = {
        dateType: dateType,
        startTime: this.filters.startDate,
      };
      exportExcel("dataTable", name, selectedDate);
    },
  },
};
</script>

<style lang="scss" scoped>
.fl {
  float: left;
}
.page-container {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  // background-color: #fff;
  padding: 12px;
  display: flex;
  .content-left {
    margin-right: 12px;
    padding: 12px 0 12px 0;
    width: 240px;
    height: 100%;
    box-sizing: border-box;
    background-color: #fff;
    border-radius: 4px;
    overflow: auto;
  }
  .content-right {
    padding: 12px;
    height: 100%;
    flex: 1;
    box-sizing: border-box;
    background-color: #fff;
    border-radius: 4px;
    overflow: auto;
    .content {
      width: 100%;
      overflow: auto;
      height: calc(100% - 56px);
    }
  }
}
</style>
